import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-authorities',
    template: require('../shared/list-view.html')
})
export class Authorities extends ListBase<Nema.Crew.Model.Authority>  {
    constructor(
        @Inject("authorities") authorities: Nema.Crew.Model.Authority[],
        crewPermissionsService: CrewPermissionsService) {

        super(authorities, crewPermissionsService);
    }

    public newEntityState = "app.settings.authorities.new";

    public editEntityState = "app.settings.authorities.detail";

    public entityName = "Authority";

    public entityNames = "Authorities";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/authorities/authorities.component.ts